import { render, staticRenderFns } from "./faqs-list.vue?vue&type=template&id=43fa1f4d&"
import script from "./faqs-list.vue?vue&type=script&lang=js&"
export * from "./faqs-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports